// extracted by mini-css-extract-plugin
module.exports = {"col6From1450":"IncludedBanner_col6From1450__m2qJG","textContent":"IncludedBanner_textContent__aHZBk"};